import React from "react";
import { Row } from 'react-bootstrap';
import "./DisplayLaptop.css"
import logic from './logic.js'
import LaptopCard from "../../components/LaptopCard"
import { RenderIf } from "@alanngo/custom-components/dist";

const DisplayLaptop = ({ laptops = [] }) =>
(
  <div align="center">
    <RenderIf condition={laptops.length > 0} fallback={<>no laptops found</>}>
      <Row xs={1} md={3}>
        {
          laptops.map((laptop) =>
          (
            <LaptopCard
              key={laptop._id}
              laptop={laptop}
              category={logic.getCategory(laptop.category)}
              cpuLogo={logic.getCPU(laptop.cpu, "70")}
              gpuLogo={logic.getGPU(laptop.gpu, "70")}
            />))
        }
      </Row>
    </RenderIf>

  </div>
)

export default DisplayLaptop;
